
export default function Autorizacion() {

    return (
        <div className='row'>
            <embed src={require('./../img/autorizacion.pdf')} type="application/pdf" width="100%" height="600px" />
        </div>
    )

}